export const hasProperty = <T, K extends PropertyKey>(
  obj: T,
  prop: K,
): obj is T & Record<K, unknown> => typeof obj === 'object' && obj !== null && prop in obj;
